import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./TenderFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import TenderFormStepOne from "./TenderFormSteps/TenderFormStepOne";
import TenderFormStepTwo from "./TenderFormSteps/TenderFormStepTwo";

const TenderForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues:_initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update) {
      setInitialValues({
       ..._initialValues,
       model:_initialValues?.model?.uuid ? {value:_initialValues?.model?.uuid} : null,
       typeOfCar:_initialValues?.typeOfCar?.uuid ? {value:_initialValues?.typeOfCar?.uuid} : null,
       property:_initialValues?.property?.uuid ? {value:_initialValues?.property?.uuid} : null,
       driver:_initialValues?.driver?.uuid ? {value:_initialValues?.driver?.uuid} : null
      });
      return;
    }

    setInitialValues({
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="TenderForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <TenderFormStepOne {...formProps} {...props} />
              <TenderFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default TenderForm;
